module.exports = __webpack_public_path__ + "static/03-96c69af1ac8a606a0261c2cb6e6da220.jpg";